































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";

@Component({
	components: {}
})
export default class EditableTableData extends Vue {
	@Prop({ type: Boolean, default: true }) private disabled: boolean;
	private editing: boolean = false;

	private tooltipOptions = {
		interactive: false,
		animation: false,
		placement: "auto",
		delay: 0
	};

	public get title() {
		return !this.disabled ? "Click to edit" : "";
	}

	public triggerEdit() {
		if (!this.disabled) {
			this.editing = true;
		}
	}

	@Emit("finish-edit")
	public finishEdit() {
		this.editing = false;
	}
}
